module.exports = __webpack_public_path__ + "static/media/Submit Your Tip.3e3f69a9.csv";